import React, { forwardRef } from "react";
import clsx from "clsx";

const Checkbox = forwardRef(({
  label,
  description,
  error,
  disabled = false,
  className = "",
  id,
  ...props
}, ref) => {
  const checkboxId = id || `checkbox-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={clsx("relative flex items-start", className)}>
      <div className="flex items-center h-5">
        <input
          ref={ref}
          type="checkbox"
          id={checkboxId}
          disabled={disabled}
          className={clsx(
            "w-4 h-4 rounded border-dark-300 dark:border-dark-600",
            "text-primary-500 focus:ring-primary-500 focus:ring-offset-0",
            "bg-white dark:bg-dark-800",
            "transition-colors duration-200",
            "disabled:opacity-50 disabled:cursor-not-allowed",
            error && "border-danger-500"
          )}
          {...props}
        />
      </div>
      {(label || description) && (
        <div className="ml-3">
          {label && (
            <label
              htmlFor={checkboxId}
              className={clsx(
                "text-sm font-medium",
                disabled
                  ? "text-dark-400 dark:text-dark-500 cursor-not-allowed"
                  : "text-dark-700 dark:text-dark-300 cursor-pointer"
              )}
            >
              {label}
            </label>
          )}
          {description && (
            <p className="text-xs text-dark-500 dark:text-dark-400">
              {description}
            </p>
          )}
          {error && (
            <p className="text-xs text-danger-500 mt-1">{error}</p>
          )}
        </div>
      )}
    </div>
  );
});

Checkbox.displayName = "Checkbox";

// Checkbox Group component
const CheckboxGroup = ({
  label,
  children,
  error,
  className = "",
  orientation = "vertical",
}) => {
  return (
    <fieldset className={className}>
      {label && (
        <legend className="text-sm font-medium text-dark-700 dark:text-dark-300 mb-2">
          {label}
        </legend>
      )}
      <div
        className={clsx(
          "space-y-2",
          orientation === "horizontal" && "sm:flex sm:space-y-0 sm:space-x-6"
        )}
      >
        {children}
      </div>
      {error && <p className="text-xs text-danger-500 mt-2">{error}</p>}
    </fieldset>
  );
};

Checkbox.Group = CheckboxGroup;

export default Checkbox;
